// URLS
export const BANK = "/bank";
export const DASHBOARD = "/dashboard";
export const PROFILE = "/profile";
export const TWOFA = "/two-fa";
export const REQUEST_VERIFY = "/withdrawal-verify";
export const INDEX = "/index";

export const NOTIFICATION = "/notification";
export const TRADER_CHANGE_PASSWORD = "/account/change/password";
export const CHANGE_LEVERAGE = "/change-leverage";
export const INTERNAL_TRANSFER = "/internal-transfer";
export const ACCOUNT_VERIFY = "/account-verify";

export const CREATE_LIVE_ACCOUNT = "/create-live-account";
export const CREATE_DEMO_ACCOUNT = "/create-demo-account";

export const ACCOUNT_LIST = "/account-list";
export const OPEN_TRADES = "/open-trades";
export const OPEN_ORDERS = "/open-orders";
export const WITHDRAWAL = "/withdrawal";

export const WITHDRAWAL_LIST = "/withdrawal-list";
export const DEPOSIT = "/deposit";
export const DEPOSIT_LIST = "/deposit-list";
export const BONUS = "/bonus";
export const BONUS_LIST = "/bonus-list";
export const REMOVE_BONUS = "/remove-bonus";
export const SUPPORT = "/support/:tabName";
export const VIEW = "/view";

// Routing persistance
export const MAX_TIME_TO_RETURN = 10 * 1000; // 10 seconds
export const LS_ROUTE_KEY = "example:route";
export const LS_LAST_ACTIVITY_AT_KEY = "example:last-active-at";


// WEBPACK FOOTER //
// ./src/consts.js